import * as React from 'react';
export const IcRupee = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 8h-2.1c-.15-.74-.47-1.42-.91-2H17c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h3a3 3 0 012.82 2H7c-.55 0-1 .45-1 1s.45 1 1 1h5.83a3.001 3.001 0 01-2.81 2H7s-.07 0-.11.01h-.05c-.05 0-.09.02-.14.03-.02 0-.03 0-.05.01-.04.02-.09.04-.13.06-.02 0-.03.02-.05.03-.04.02-.08.05-.11.08-.02.01-.03.02-.05.04l-.1.1c0 .01-.02.02-.03.03v.01c-.03.04-.05.08-.07.12l-.03.06c-.01.03-.03.07-.04.1 0 .03-.02.06-.03.09 0 .03 0 .05-.01.08 0 .04-.01.08-.01.12v.07c0 .04 0 .09.01.13 0 .02.01.04.02.06.01.04.02.08.04.13 0 .02.02.04.02.05.02.04.04.08.07.12 0 .01.02.03.03.04.03.04.06.08.09.11.01.01.02.02.04.03.03.02.05.05.08.07l8 6c.18.14.39.2.6.2.3 0 .6-.14.8-.4.33-.44.24-1.07-.2-1.4l-5.6-4.2c2.41 0 4.43-1.72 4.9-4h2.1c.55 0 1-.45 1-1s-.45-1-1-1L17 8z'
      fill='currentColor'
    />
  </svg>
);
